import { render } from "./ScienceSettings.vue?vue&type=template&id=2969ab22"
import script from "./ScienceSettings.vue?vue&type=script&lang=js"
export * from "./ScienceSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__